import { DeviceFragment } from '@/shared/types/types.generated';

export const useLinkedGatewaysForDevice = (device?: DeviceFragment) => {
  const linkedGateways = device?.linkedGateways?.items ?? [];
  const primaryGateway =
    linkedGateways?.find((gateway) => gateway.linkMetaData?.primary) ??
    linkedGateways?.[0];

  return {
    linkedGateways,
    primaryGateway,
  };
};
